import { useState } from 'react';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import {
  ThanksModal,
  thanksTable,
  ThanksTableVerbiage,
} from 'src/common/utils/ThanksModal';

export interface thanksProps {
  bpName: string;
  useTranslation: TranslationFunction;
}

const Thanks = ({ bpName, useTranslation }: thanksProps) => {
  const [showThanksModal, setShowThanksModal] = useState(true);

  const titleThanks: ThanksTableVerbiage[] = [
    { group: 'title', value: useTranslation('thank_text') },
    {
      group: 'widgetTitle2',
      value: useTranslation('thank_desc'),
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: '',
    },
  ];
  const contentThanks: ThanksTableVerbiage[] = [];
  bpName &&
    contentThanks.push({
      group: useTranslation('bp_title'),
      value: bpName,
    });

  const buttonThanks: ThanksTableVerbiage[] = [
    {
      group: 'button1',
      value: useTranslation('return_assessment'),
    },
  ];

  return (
    <div>
      <ThanksModal
        showThanksModal={showThanksModal}
        pageTitle="Mass360 Assessment Page"
        object="Pricing Page"
        productTitle={'MaaS360 Plan Assessment'}
        pageUrl={'/products/maas360/pricing'}
        location={'Estimator'}
        titleThanks={titleThanks}
        widgetTitleThanks={widgetTitleThanks}
        contentThanks={contentThanks}
        buttonThanks={buttonThanks}
        setShowThanksModal={setShowThanksModal}
      />
    </div>
  );
};

export default Thanks;
